import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  getAddress,
  getInfosBusiness,
  getSchoolSectors,
  getSchoolSize,
  updateBusinessInfoVitrine,
} from '@webapps/business';
import {
  Button,
  FormikAutocomplete,
  FormikAutocomplete50,
  FormikAutocomplete50Filled,
  FormikDatePicker,
  FormikTextFieldPx,
  TextFieldPx,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { add, format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import * as yup from 'yup';

import theme from '../theme';
import Description from './Description';
import GoodToKnow from './GoodToKnow';
import WhatTheySeek from './WhatTheySeek';
import { PRIVATEORPUBLIC } from 'config/constants';

const {
  colors: { background, subTextColor },
} = theme;

const Presentation = ({
  infosVitrine,
  isLoading,
  refetch,
  description,
  goodtoknow,
  whattheyseek,
}) => {
  const {
    classes,
    cx,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [disabledSocial, setDisabledSocial] = useState(true);
  const { idUser } = useAuth();

  const { data: sizes = [] } = useQuery(getSchoolSize, {
    key: 'sizeEntreprise2',
    keepPreviousData: true,
  });

  const { data: sectors = [] } = useQuery(getSchoolSectors, {
    key: 'sectorsEntreprise2',
    keepPreviousData: true,
  });

  const {
    error,
    isLoading: isLoadingUpdate,
    isSuccess,
    mutateAsync: mutateUpdateInfos,
  } = useMutation(updateBusinessInfoVitrine);

  const { addToast } = useToast();

  const [addresses, setAddresses] = useState([]);
  const [headOffices, setHeadOffices] = useState([]);

  const formik = useFormik({
    initialValues: {
      foundationDate: infosVitrine?.foundationDate || '',
      address: {
        label: infosVitrine?.address?.label || '',
        city: infosVitrine?.address?.city || '',
        cityCode: infosVitrine?.address?.cityCode || '',
      },
      headOffice: {
        label: infosVitrine?.headOffice?.label || '',
        city: infosVitrine?.headOffice?.city || '',
        cityCode: infosVitrine?.headOffice?.cityCode || '',
      },
      website: infosVitrine?.website || '',
      facebook: infosVitrine?.facebook || '',
      youtube: infosVitrine?.youtube || '',
      instagram: infosVitrine?.instagram || '',
      linkedin: infosVitrine?.linkedin || '',
      pinterest: infosVitrine?.pinterest || '',
      twitter: infosVitrine?.twitter || '',
      tiktok: infosVitrine?.tiktok || '',
      sector: {
        id:
          sectors?.find(({ label }) => label === infosVitrine?.sector?.label)
            ?.id || '',
      },
      size: {
        id: sizes?.find(({ id }) => id === infosVitrine?.size?.id)?.id || '',
      },
      organization: infosVitrine?.organization || '',
      phone: infosVitrine?.phone || '',
      siret: infosVitrine?.siret || "SIRET en cours d'attribution",
      name: infosVitrine?.name || '',
      email: infosVitrine?.email || '',
    },
    enableReinitialize: true,
    onSubmit: ({ foundationDate, sector, size, ...values }) => {
      mutateUpdateInfos({
        data: {
          sector: sector.id !== '' ? sector : null,
          size: size.id !== '' ? size : null,
          foundationDate: foundationDate
            ? format(new Date(foundationDate), "yyyy-MM-dd'T'HH:mm:ss")
            : new Date(),
          ...values,
        },
        id: idUser,
      });
    },
  });

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Modification effectuée !',
      });
      refetch();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [error]);

  const handleOrganizationChange = (event) => {
    const selectedValue = event.target.value;
    const isPublic = selectedValue === 'true';

    formik.setFieldValue('organization', isPublic);
    formik.handleSubmit();
  };


  const handleSizeChange = (event) => {
    const selectedValue = event.target.value;
    const newSize = sizes.find(({ id }) => id === selectedValue);
    formik.setFieldValue('sizes', newSize);
    formik.handleSubmit();
  };

  const getAdresses = useMutation(getAddress, {
    onSuccess: (data) => {
      setAddresses(data?.data?.features);

      formik.setFieldValue(
        'address.label',
        data?.data?.features[0]?.properties?.label
      );
      formik.setFieldValue(
        'address.city',
        data?.data?.features[0]?.properties?.city
      );
      formik.setFieldValue(
        'address.cityCode',
        data?.data?.features[0]?.properties?.postcode
      );
    },
  });

  const getHeadOffices = useMutation(getAddress, {
    onSuccess: (data) => {
      setHeadOffices(data?.data?.features);

      formik.setFieldValue(
        'headOffice.label',
        data?.data?.features[0]?.properties?.label
      );
      formik.setFieldValue(
        'headOffice.city',
        data?.data?.features[0]?.properties?.city
      );
      formik.setFieldValue(
        'headOffice.cityCode',
        data?.data?.features[0]?.properties?.postcode
      );
    },
  });

  const handleChangeAddress = async (searchValue) => {
    if (!searchValue.target.value || searchValue.target.value.length < 3) return;
    await getAdresses.mutateAsync({ name: searchValue.target.value });
  };

  const handleChangeHeadOffice = async (searchValue) => {
    if (!searchValue.target.value || searchValue.target.value.length < 3) return;
    await getHeadOffices.mutateAsync({ name: searchValue.target.value });
  };

  const handleCloseCoor = () => {
    setDisabledCoord(true);
  };

  const handleCloseUpdateCoor = () => {
    formik.handleSubmit();
    setDisabledCoord(true);
  };

  const handleChangePhone = (phoneInfo) => {
    if (phoneInfo) {
      setPhone(phoneInfo);
      if (isValidPhoneNumber(phoneInfo)) {
        setErrorPhone(false);
        setPhoneClasses('phoneInput');
      } else {
        setErrorPhone(true);
        setPhoneClasses('phoneInputError');
      }
    }
  };

  const [disabledCoord, setDisabledCoord] = useState(true);
  const [disabledSupInfos, setDisabledSupInfos] = useState(true);

  const handleCloseSocials = () => {
    setDisabledSocial(true);
  };

  const handleSubmitSocials = () => {
    formik.handleSubmit();
    setDisabledSocial(true);
  };

  const [phone, setPhone] = useState('');
  const [errorPhone, setErrorPhone] = useState(false);
  const [phoneInput, setPhoneInput] = useState(false);
  const [phoneClasses, setPhoneClasses] = useState('phoneInput');
  const phoneClassesRef = useRef();
  phoneClassesRef.current = phoneClasses;

  const handleWebsiteLinkChange = (event) => {
    const selectedValue = event.target.value;

    formik.setFieldValue('website', selectedValue);
    formik.handleSubmit();
  };

  const handleFacebookLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.facebook.com')) {
      formik.setFieldValue('facebook', selectedValue);
    } else if (!selectedValue) {
      formik.setFieldValue('facebook', '');
    } else {
      formik.setFieldValue('facebook', `https://www.facebook.com/${selectedValue}/`);
    }

    formik.handleSubmit();
  };

  const handleInstagramLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.instagram.com')) {
      formik.setFieldValue('instagram', selectedValue);
    } else if (!selectedValue) {
      formik.setFieldValue('instagram', '');
    } else {
      formik.setFieldValue('instagram', `https://www.instagram.com/${selectedValue}/`);
    }

    formik.handleSubmit();
  };

  const handleLinkedInLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.linkedin.com')) {
      formik.setFieldValue('linkedin', selectedValue);
    } else if (!selectedValue) {
      formik.setFieldValue('linkedin', `https://www.linkedin.com/${selectedValue}`);
    } else {
      formik.setFieldValue('linkedin', `https://www.linkedin.com/in/${selectedValue}/`);
    }

    formik.handleSubmit();
  };

  const handleYoutubeLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.youtube.com')) {
      formik.setFieldValue('youtube', selectedValue);
    } else if (selectedValue.includes('/@')) {
      formik.setFieldValue('youtube', `https://www.youtube.com/${selectedValue}`);
    } else if (!selectedValue) {
      formik.setFieldValue('youtube', '');
    } else {
      formik.setFieldValue('youtube', `https://www.youtube.com/channel/${selectedValue}`);
    }

    formik.handleSubmit();
  };

  const handleTikTokLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.tiktok.com')) {
      formik.setFieldValue('tiktok', selectedValue);
    } else if (!selectedValue) {
      formik.setFieldValue('tiktok', '');
    } else {
      formik.setFieldValue('tiktok', `https://www.tiktok.com/${selectedValue}`);
    }

    formik.handleSubmit();
  };

  const handleTwitterLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.x.com')) {
      formik.setFieldValue('twitter', selectedValue);
    } else if (!selectedValue) {
      formik.setFieldValue('twitter', '');
    } else {
      formik.setFieldValue('twitter', `https://www.x.com/${selectedValue}`);
    }

    formik.handleSubmit();
  };

  const handlePinterestLinkChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes('https://www.pinterest.com')) {
      formik.setFieldValue('pinterest', selectedValue);
    } else if (!selectedValue) {
      formik.setFieldValue('pinterest', '');
    } else {
      formik.setFieldValue('pinterest', `https://www.pinterest.com/${selectedValue}`);
    }

    formik.handleSubmit();
  };

  return (
    <>
      {isLoading ? (
        'Chargement'
      ) : (
        <>
          <div
            className={classes.container}
            style={{
              borderBottomRightRadius: 10,
              borderBottomLeftRadius: 10,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }}
          >
            <div
              className={css({
                display: 'flex',
                justifyContent: 'space-between',
                '@media (max-width:768px)': {
                  display: 'flex',
                  flexDirection: 'column',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '8px',
                }}
              >
                <div className={global.title}>
                  <FormattedMessage id="Coordonnées" />
                </div>
                <div className={global.subTitle}>
                  Indiquez les informations qui aideront les utilisateurs à plus facilement vous trouver
                </div>
              </div>
              {!disabledCoord && (
                <div
                  className={css({
                    display: 'flex',
                    '@media (max-width:768px)': {
                      marginTop: spacing(2.5),
                      justifyContent: 'flex-end',
                    },
                  })}
                >
                  <Button
                    className={classes.btnModify}
                    style={{
                      backgroundColor: '#F50057',
                      marginRight: spacing(2),
                      color: 'white',
                      padding: spacing(2),
                    }}
                    onClick={handleCloseCoor}
                    disabled={isLoadingUpdate}
                  >
                    <FormattedMessage id="Annuler" />
                  </Button>
                  <Button
                    className={classes.btnModify}
                    style={{
                      backgroundColor: '#0060F9',
                      marginRight: spacing(2),
                      color: 'white',
                      padding: spacing(2),
                    }}
                    onClick={handleCloseUpdateCoor}
                    disabled={isLoadingUpdate}
                  >
                    <FormattedMessage id="Enregistrer" />
                  </Button>
                </div>
              )}
            </div>
            <Grid
              container
              className={classes.gapBetweenItems}
              style={{ marginTop: 20 }}
              spacing={1}
            >
              <Grid item xs={12} sm={6} md={4} className={classes.textfield}>
                <PhoneInput
                  className={`${classes[phoneClassesRef.current]}`}
                  countryCallingCodeEditable={false}
                  defaultCountry="FR"
                  defaultValue={phone}
                  international
                  limitMaxLength
                  name="phone"
                  onChange={(phone) => {
                    handleChangePhone(phone);
                  }}
                  onBlur={() => {
                    if (phoneClassesRef.current === 'phoneInputError') {
                      addToast({
                        status: 'error',
                        message: 'Numéro de téléphone invalide',
                      });
                    } else {
                      formik.setFieldValue('phone', phone);
                      formik.handleSubmit();
                    }
                  }}
                  value={formik.values.phone}
                />
              </Grid>
              <Grid item xs>
                <Autocomplete
                  autoComplete={false}
                  disableUnderLine="true"
                  fullWidth
                  defaultValue={infosVitrine?.address?.label}
                  classes={{
                    root: css({
                      height: '100%',
                    }),
                  }}
                  getOptionLabel={(option) => option || ''}
                  options={addresses?.map(
                    (option) => option?.properties?.label
                  )}
                  renderInput={(params) => (
                    <TextFieldPx
                      {...params}
                      defaultValue={infosVitrine?.address?.label}
                      label={<FormattedMessage id="vitrine.address" />}
                      name="address.label"
                      fullWidth
                      inputPadding={"14px 12px 0px 6px"}
                      borderRadius={6}
                      classes={{
                        root: css({
                          flexDirection: 'row',
                        }),

                      }}
                      className={css({
                        padding: '0 0 0 8px !important',
                        '.MuiAutocomplete-input': {
                          padding: '0 0 0 8px !important'
                        },
                      })}
                      onChange={(value) => {
                        handleChangeAddress(value);
                      }}
                      value={infosVitrine?.address?.label}
                      variant="filled"
                    />
                  )}
                  onBlur={() => { formik.handleSubmit() }}
                  size="small"
                />
              </Grid>
              <Grid item xs>
                <FormikTextFieldPx
                  formik={formik}
                  defaultValue={infosVitrine?.email}
                  fullWidth
                  borderRadius={6}
                  disableUnderLine={true}
                  onBlur={() => { formik.handleSubmit() }}
                  label={<FormattedMessage id="Adresse email" />}
                  name="email"
                  inputProps={{
                    className: cx(classes.infoBox),
                    disableUnderLine: true,
                  }}
                  InputProps={{
                    disableUnderLine: true,
                  }}
                  variant="filled"
                />
              </Grid>
            </Grid>
          </div>
          <div className={classes.container} style={{ marginTop: '20px' }}>
            <div
              className={css({
                display: 'flex',
                justifyContent: 'space-between',
                '@media (max-width:768px)': {
                  display: 'flex',
                  flexDirection: 'column',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '8px',
                }}
              >
                <div className={global.title}>
                  <FormattedMessage id="Informations supplémentaires" />
                </div>
                <div className={global.subTitle}>
                  Indiquez les informations qui décrivent votre entreprise
                </div>
              </div>
            </div>
            <Grid container spacing={1} style={{ marginTop: 20 }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormikTextFieldPx
                  disabled="true"
                  formik={formik}
                  fullWidth
                  borderRadius={6}
                  label={
                    <FormattedMessage
                      style={{ color: '#152652' }}
                      id="Type d'organisme"
                    />
                  }
                  name="address.city"
                  className={css({
                    color: '#152652',
                  })}
                  inputProps={{
                    className: cx(
                      classes.infoBox,
                      classes.infoBoxDisabled
                    ),
                  }}
                  variant="filled"
                  value="Entreprise"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormikAutocomplete50Filled
                  defaultValue=""
                  className={classes.inputSize}
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  classes={{
                    root: css({
                      color: 'red',
                    }),
                  }}
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) =>
                    value.sector === option.id
                  }
                  name="sector.id"
                  options={sectors}
                  pathValue="id"
                  value={
                    sectors.find(({ id }) => id === formik.values?.sector?.id) ||
                    null
                  }
                  renderInput={(params) => (
                    <TextFieldPx
                      {...params}
                      inputPadding={"14px 12px 0px 6px"}
                      label={<FormattedMessage id="vitrine.sector" />}
                      name="sector.id"
                      borderRadius={6}
                      onBlur={() => { formik.handleSubmit() }}
                      value={formik.values?.sector?.id}
                      variant="filled"
                    />
                  )}
                  onBlur={() => { formik.handleSubmit() }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormikTextFieldPx
                  formik={formik}
                  fullWidth
                  borderRadius={6}
                  defaultValue={infosVitrine?.organization}
                  disableUnderLine="true"
                  label={<FormattedMessage id="Organisme" />}
                  name="organization"
                  inputProps={{
                    className: cx(
                      classes.infoBox,
                      css({ cursor: disabledSupInfos ? 'pointer' : 'default' })
                    ),
                  }}
                  variant="filled"
                  select
                  onBlur={handleOrganizationChange}
                  value={formik.values.organization ? 'true' : 'false'}
                >
                  {PRIVATEORPUBLIC.map(({ label, value }, index) => (
                    <MenuItem key={index} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </FormikTextFieldPx>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormikAutocomplete50Filled
                  defaultValue=""
                  className={classes.inputSize} // Utilisation de la même classe CSS
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  classes={{
                    root: css({
                      color: 'red', // Même style que le premier composant
                    }),
                  }}
                  getOptionLabel={(option) =>
                    `${option.min.toString()} - ${option.max.toString()}` || ''
                  }
                  getOptionSelected={(option, value) => value?.id === option?.id}
                  name="size.id"
                  options={sizes}
                  pathValue="id"
                  value={
                    sizes.find(({ id }) => id === formik.values.size.id) || null
                  }
                  renderInput={(params) => (
                    <TextFieldPx
                      {...params}
                      inputPadding={"14px 12px 0px 6px"} // Identique au premier composant
                      label={<FormattedMessage id="vitrine.tailleEntreprise" />}
                      name="size.id"
                      borderRadius={6}
                      onBlur={() => {
                        formik.handleSubmit();
                      }}
                      value={formik.values?.size?.id}
                      variant="filled" // Même variante utilisée
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  disableUnderLine="true"
                  autoComplete={false}
                  defaultValue={infosVitrine?.headOffice?.label}
                  getOptionLabel={(option) => option || ''}
                  classes={{
                    root: css({
                      height: '100%',
                    }),
                  }}
                  options={headOffices?.map(
                    (option) => option?.properties?.label
                  )}
                  renderInput={(params) => (
                    <TextFieldPx
                      {...params}
                      defaultValue=""
                      inputPadding={"14px 12px 0px 6px"}
                      borderRadius={6}
                      label={<FormattedMessage id="vitrine.siege" />}
                      name="headOffice.label"
                      classes={{
                        root: css({
                          flexDirection: 'row',
                        }),
                      }}
                      onChange={(value) => {
                        handleChangeHeadOffice(value);
                      }}
                      value={formik.values.headOffice.label}
                      variant="filled"
                    />
                  )}
                  onBlur={() => { formik.handleSubmit() }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormikDatePicker
                  disableUnderLine="true"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  formik={formik}
                  fullWidth
                  name="foundationDate"
                  variant="filled"
                  borderRadius={6}
                  onChange={(value) => {
                    const selectedDate = format(
                      new Date(value),
                      "yyyy-MM-dd'T'HH:mm:ss"
                    );
                    formik.setFieldValue('foundationDate', selectedDate);
                    formik.handleSubmit();
                  }}
                  label={<FormattedMessage id="Date de création" />}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Description presentation={description} />
          </div>
          <div>
            <GoodToKnow goodtoknow={goodtoknow} />
          </div>
          <div>
            <WhatTheySeek whattheyseek={whattheyseek} />
          </div>
          <div
            className={classes.container}
            style={{ marginTop: '20px' }}
          >
            <div
              className={css({
                display: 'flex',
                justifyContent: 'space-between',
                '@media (max-width:768px)': {
                  display: 'flex',
                  flexDirection: 'column',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '8px',
                }}
              >
                <div className={global.title}>
                  <FormattedMessage id="Liens externes" />
                </div>
                <div className={global.subTitle}>
                  <FormattedMessage id="Indiquez votre présence sur le web" />
                </div>
              </div>

              {!disabledSocial && (
                <div
                  className={css({
                    display: 'flex',
                    '@media (max-width:768px)': {
                      marginTop: spacing(2.5),
                      justifyContent: 'flex-end',
                    },
                  })}
                >
                  <Button
                    className={classes.btnModify}
                    style={{
                      backgroundColor: '#F50057',
                      marginRight: spacing(2),
                      color: 'white',
                      padding: spacing(2),
                    }}
                    onClick={handleCloseSocials}
                    disabledSocial={isLoadingUpdate}
                  >
                    <FormattedMessage id="Annuler" />
                  </Button>
                  <Button
                    className={classes.btnModify}
                    style={{
                      backgroundColor: '#0060F9',
                      marginRight: spacing(2),
                      color: 'white',
                      padding: spacing(2),
                    }}
                    onClick={handleSubmitSocials}
                    disabledSocial={isLoadingUpdate}
                  >
                    <FormattedMessage id="Enregistrer" />
                  </Button>
                </div>
              )}
            </div>
            <Grid
              container
              spacing={2}
              className={css({
                marginTop: spacing(2.5),
              })}
            >
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Site web" />}
                  name="website"
                  onBlur={handleWebsiteLinkChange}
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Facebook" />}
                  name="facebook"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handleFacebookLinkChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Instagram" />}
                  name="instagram"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handleInstagramLinkChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="LinkedIn" />}
                  name="linkedin"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handleLinkedInLinkChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Youtube" />}
                  name="youtube"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handleYoutubeLinkChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Tiktok" />}
                  name="tiktok"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handleTikTokLinkChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Twitter" />}
                  name="twitter"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handleTwitterLinkChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormikTextFieldPx
                  formik={formik}
                  disableUnderLine="true"
                  fullWidth
                  borderRadius={6}
                  label={<FormattedMessage id="Pinterest" />}
                  name="pinterest"
                  inputProps={{
                    className: cx(classes.infoBox),
                  }}
                  variant="filled"
                  onBlur={handlePinterestLinkChange}
                />
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

const styles = ({ spacing }) => ({
  responsiveContainer: {
    display: 'flex',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  container: {
    background,
    borderRadius: 10,
    maxWidth: '100%',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'Montserrat',
  },
  modifyLink: {
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
    padding: spacing(0),
    wordWrap: 'break-word',
    maxWidth: '100%',
  },
  btnModify: {
    padding: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 0,
    fontWeight: 400,
    color: '#0060F9',
    border: 'none',
    '&:hover': {
      border: 'none',
      backgroundColor: 'white',
      textDecoration: 'none',
    },
    '@media screen and (max-width: 768px)': {
      width: '5vw',
    },
  },
  infoBox: {
    borderRadius: '5px',
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    backgroundColor: '#F3F7FF',
    display: 'flex',
    alignItems: 'center',
  },
  infoBoxDisabled: {
    borderRadius: '5px',
    color: '#5D75A8',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    backgroundColor: '#FFFFFF',
  },
  infoBoxCoord: {
    padding: spacing(0, 2),
    borderRadius: '5px',
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    backgroundColor: '#F3F7FF',
  },
  infoBoxGender: {
    borderRadius: '5px',
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Roboto',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#F3F7FF',
  },
  autoCompleteInfoBox: {
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
    fontFamily: 'Roboto',
    backgroundColor: '#F3F7FF',
    border: '1px solid #C0D9FF',
  },
  personalAddress: {
    padding: spacing(0, 2.5, 0, 0),
    margin: 0,
    '@media (max-width:768px)': { padding: spacing(0, 2.5, 2.5, 0) },
  },
  personalAddressAC: {
    padding: spacing(0, 2.5, 0, 0),
    '@media (max-width:768px)': { padding: spacing(0, 2.5, 2.5, 0) },
  },

  phoneInput: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F3F7FF',
      borderRadius: 5,
      padding: spacing(0, 2),
      height: '100%',
      color: '#152652',
      border: '1px #C0D9FF solid',
    },
  },
  phoneInputError: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F3F7FF',
      borderRadius: 5,
      padding: spacing(0, 2),
      height: '100%',
      color: '#f44336',
      border: '1px red solid',
    },
  },
  phoneError: {
    display: 'flex',
    width: '100%',
    '& > *': {
      width: '50%',
      border: '1px red solid',
    },
  },
  gapBetweenItems: {
    display: 'flex',
    flexDirection: 'row',
    '@media (max-width: 768px)': { flexDirection: 'column' },
  },
  inputSize: {
    '& .MuiAutocomplete-inputRoot': {
      height: '100%',
    },
  },
});

Presentation.propTypes = {
  infosVitrine: PropTypes.object,
  isLoading: PropTypes.bool,
  refetch: PropTypes.func,
  description: PropTypes.object,
  goodtoknow: PropTypes.object,
  whattheyseek: PropTypes.object,
};

export default Presentation;
